import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";


const StoreSettingsPage = lazy(() => import("./pages/StoreSettingsPage").then(module => ({ default: module.StoreSettingsPage })));
const AreaRatesPage = lazy(() => import("./pages/area-rates/AreaRatesPage").then(module => ({ default: module.AreaRatesPage })));

function StoreSettingsRoute() {
  const { storeSlug = "" } = useParams();

  return <StoreSettingsPage storeSlug={storeSlug} />;
}

function AreaRatesRoute() {
  const { storeSlug = "", governorateId = "" } = useParams();

  return <AreaRatesPage storeSlug={storeSlug} governorateId={governorateId} />;
}

export const settingsRoutes: RouteObject[] = [
  {
    path: "settings",
    element: <RouteSuspense><StoreSettingsRoute /></RouteSuspense>,
  },
  {
    // Full-screen drill-down (real route, not a modal) so browser/Android
    // back works and the page is reachable directly from the shipping
    // panel's governorate rows — never nested inside the rule editor.
    path: "settings/shipping/areas/:governorateId",
    element: <RouteSuspense><AreaRatesRoute /></RouteSuspense>,
  },
];
